import ContactPage from "@/common/components/contact/ContactPage";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const Contact = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.CONTACT_US}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <ContactPage />
    </>
  );
};
export default Contact;
